module.exports = __webpack_public_path__ + "img/unlock-button-red-01hover.78f5657c.png";